import { IsInt, IsNotEmpty } from 'class-validator';

export class MarkPendingDto {
  @IsInt()
  @IsNotEmpty()
  managerEmployeeId: number;
}